import { render, staticRenderFns } from "./StackedBar.vue?vue&type=template&id=4115ab4c"
import script from "./StackedBar.vue?vue&type=script&lang=js"
export * from "./StackedBar.vue?vue&type=script&lang=js"
import style0 from "./StackedBar.vue?vue&type=style&index=0&id=4115ab4c&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/mnt/disk1/buildAgent/work/8268df4d62037a26/vAnalyticsJS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4115ab4c')) {
      api.createRecord('4115ab4c', component.options)
    } else {
      api.reload('4115ab4c', component.options)
    }
    module.hot.accept("./StackedBar.vue?vue&type=template&id=4115ab4c", function () {
      api.rerender('4115ab4c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/vueComponents/dashboardContainer/src/panels/StackedBar.vue"
export default component.exports